import { defer, LoaderFunctionArgs } from 'react-router-dom';
import { fromBase64 } from 'js-base64';
import { IDexBigTrade, IFetchBigTradesPayload } from '@kattana-io/common';
import { KattanaAPI } from '../../store/createStore';
import { ITableSort } from '../../molecules/Table/DesktopTable';

export type bigTradesPageLoaderDataType = IDexBigTrade[] | null;

const bigTradesLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const network = url.searchParams.get('chain') || 'ETH';
  const side = url.searchParams.get('side') || undefined;
  const total = url.searchParams.get('total') || undefined;
  const sort = url.searchParams.get('sort');

  const payload: IFetchBigTradesPayload = { network, side };

  if (sort) {
    const parsedSort: ITableSort = JSON.parse(fromBase64(sort));
    payload.sort = {
      name: parsedSort.id,
      order: parsedSort.isSortedDesc ? 'DESC' : 'ASC',
    };
  }

  const trades = KattanaAPI.bigTrades(
    total || '10000',
    '100',
    payload,
    request.signal
  );

  return defer({ trades });
};

export default bigTradesLoader;
